// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "li.itemList[data-v-3b543b5c] {\n  border: 1px solid #ddd;\n  display: inline-block;\n  margin-right: 8px;\n  margin-bottom: 8px;\n  cursor: pointer;\n  padding: 2px 5px;\n}", ""]);
// Exports
module.exports = exports;
